function retry(count, delay, callback, deferred, currentTry) {
    deferred = deferred || $.Deferred();
    currentTry = currentTry || 0;

    if (currentTry < count) {
        setTimeout(function () {

            var result = callback(deferred);
            result.always(function (result) {
                if (result !== "true") {
                    currentTry++;
                    retry(count, delay, callback, deferred, currentTry);
                }
            });

        }, 2000);
    } else {
        deferred.reject();
    }

    return deferred.promise();
}